<template>
    <div class="table-sorting">
        <button
            class="button button--blank table-sorting__button"
            type="button"
            :class="{ 'is-active': isActive && !isDescending }"
            @click="toggle(true)"
        >
            <svg
                width="8"
                height="7"
                viewBox="0 0 8 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.13397 0.500001C3.51887 -0.166666 4.48113 -0.166667 4.86603 0.5L7.4641 5C7.849 5.66667 7.36788 6.5 6.59808 6.5H1.40192C0.632124 6.5 0.150998 5.66667 0.535898 5L3.13397 0.500001Z"
                    fill="#C4C4C4"
                />
            </svg>
        </button>
        <button
            class="button button--blank table-sorting__button table-sorting__button--descending"
            type="button"
            :class="{ 'is-active': isActive && isDescending }"
            @click="toggle()"
        >
            <svg
                width="8"
                height="7"
                viewBox="0 0 8 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.13397 0.500001C3.51887 -0.166666 4.48113 -0.166667 4.86603 0.5L7.4641 5C7.849 5.66667 7.36788 6.5 6.59808 6.5H1.40192C0.632124 6.5 0.150998 5.66667 0.535898 5L3.13397 0.500001Z"
                    fill="#C4C4C4"
                />
            </svg>
        </button>
    </div>
</template>

<script>
import { DESCENDING_ORDER, ASCENDING_ORDER } from './utils';

export default {
    name: 'TableSorting',
    emits: ['update:modelValue'],

    props: {
        modelValue: {
            type: String,
            required: true
        },
        field: {
            type: String,
            required: true
        }
    },

    computed: {
        isActive() {
            return this.modelValue.includes(this.field);
        },
        isDescending() {
            return this.modelValue.includes(DESCENDING_ORDER);
        }
    },

    methods: {
        toggle(isAscending = false) {
            if (isAscending) {
                this.$emit('update:modelValue', `${ASCENDING_ORDER}${this.field}`);
                return;
            }

            this.$emit('update:modelValue', `${DESCENDING_ORDER}${this.field}`);
        }
    }
};
</script>

<style src="./TableSorting.scss" lang="scss"></style>
